import Vue from "vue";
import { debounce } from 'lodash';

Vue.component("notification-type-radio", {
    props: ["value",
        "language",
        "disabled",
        "label",
        "type",
        "message",
        "cssClass",
        "hasLabelInfo",
        "tooltipPosition",
        "tooltipIcon",
        "labelInfoCssClass",
        "labelInfo",
        "tooltipText",
        "tooltipValue",
        "hasTooltip",
        "hasTooltipText",
        "tooltipAsModal",
        "tooltipAsHtml",
        "tooltipTextAsHtml"
    ],
    data() {
        return {
            isFetching: false,
            data: [],
            selected: null,
            myValue: null,
            isDisabled: this.disabled,
            showModal: false
        };
    },
    watch: {
        myValue: function (val) {
            console.log(val)
            if (val) {
                

                this.$emit("update:value", val);

            }
        }
    },
    methods: {
        getAsyncData: debounce(function (query) {
            if (!query.length) {
                this.data = []
                return
            }

            this.isFetching = true;

            this.$services.notificationTypeService.getDropdownItems({
                language: this.language,
            })
                .then((data) => {
                    this.data = []
                    if (data.items) {
                        data.items.forEach((item) => this.data.push(item))
                    }
                    this.isFetching = false;
                });
        }, 500),
        showTooltip() {
            this.showModal = true;
        },
        discardModal() {
            this.showModal = false;
        },
    },
    mounted() {


        this.$services.notificationTypeService.getDropdownItems({
            language: this.language
        })
            .then((data) => {
                this.data = []
                if (data) {


                    data.forEach((item) => this.data.push(item))

                    if (this.value) {
                        this.myValue = this.value;

                    }
                }

            });

    },
    template: `
        <div>
            <div class="columns">
                <div class="column"  v-if="data.length > 0">
                    <b-field :class="cssClass"   :label="label" :type="type" :message="message">
	                    <template v-if="hasLabelInfo" #label>
                              <span class="labelInfoCssClass">{{ label }}</span>                               
			                    <b-tooltip class="custom" type="is-success" :position="tooltipPosition" multilined size="is-small" v-if="hasTooltipText && hasTooltip">
                                    <a href="#" @click.stop.prevent="showTooltip">
                                        <b-icon size="is-small" :icon="tooltipIcon"></b-icon>
                                    </a>                                    
                                    <template v-slot:content>
                                        <span v-html="tooltipText" v-if="tooltipTextAsHtml"></span>
                                        <span v-else>{{ tooltipText }}</span>
                                    </template>				                
			                    </b-tooltip>
                                <a href="#" @click.stop.prevent="showTooltip" v-else-if="!hasTooltipText && tooltipAsModal && hasTooltip">
                                    <b-icon size="is-small" :icon="tooltipIcon"></b-icon>
                                </a>
                                <b-tooltip class="custom" type="is-success" :position="tooltipPosition" multilined size="is-small" v-else>
                                    <b-icon size="is-small" :icon="tooltipIcon" ></b-icon>
                                    <template v-slot:content>
                                        <span v-html="tooltipText" v-if="tooltipTextAsHtml"></span>
                                        <span v-else>{{ tooltipText }}</span>
                                    </template>
			                    </b-tooltip>
                        </template>
                        <template v-for="(item,index) in data" >
                         <b-radio-button v-model="myValue"
                                :native-value="item.id"
                                type="is-success is-light is-outlined" :key="index">
                                <span>{{item.text}}</span>
                             </b-radio-button>
                        </template>
                  </b-field>
              </div>
          </div>
          <b-modal id="tooltipModal" ref="tooltipModal" v-model="showModal" #default="props" :can-cancel="['x','escape']">
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title" v-html="labelInfo"></p>
                    <button type="button" class="delete" @click="discardModal" />
                </header>
                <section class="modal-card-body">
                    <div class="card">
                        <div class="card-content table-container">
                            <span v-html="tooltipValue" v-if="tooltipAsHtml"></span>
                            <span v-else>{{ tooltipValue }}</span>
                        </div>
                    </div>
                </section>
            </div>
        </b-modal>
    </div>
	`
});